// @ts-nocheck


import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import Slider from 'react-slick'
import { useRouter } from 'next/router'
import { WOMEN_CATEGORY, WOMEN_CATEGORY_IMAGE } from 'src/Helpers/Json/WomanCategoryList'
import { useAppDispatch } from 'src/store/store'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useSelector } from 'react-redux'
import { fetchCategoryBySlug } from 'src/store/slices/fetchCategory'
import { fetchAllPeople } from 'src/store/slices/fetchAllPeopleSlice'

export default function ShopByWomenCategory() {
  const dispatch = useAppDispatch()
  const MobileshopByProduct = {
    className: 'center',
    // centerMode: true,
    infinite: false,
    variableWidth: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    speed: 500,
    rows: 1,
    slidesPerRow: 2,
    // responsive: [
    //   {
    //     breakpoint: 767,
    //     settings: {
    //       slidesToShow: 5,
    //     },
    //   },
    // ],
  }
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(15)
  const router = useRouter()
  const sub_category_slug = router?.pathname.split('/')[2]

  const categoryData = useSelector((state: any) => state?.fetchCategory?.womenCategoryData)

  useEffect(() => {
    dispatch(
      fetchCategoryBySlug({
        type: 'CHILD_SUB_CATEGORY',
        categoryName: 'Fashion & Accessories',
        subcategoryName: sub_category_slug,
        childsubSlug: '',
        nestedSlug: '',
      }),
    )
  }, [])

  useEffect(() => {
    dispatch(fetchAllPeople({ limit: limit, page: page, type: 'ALL_PEOPLE', prevPost: [], gender: 'Female' }))
  }, [])

  return (
    <>
      <section className="section_3">
        <div className="container">
          <div className="row section_3_row">
            <div className="left_block">
              <div className="left_cover">
                <h3>Shop By Category</h3>
                {/* <Link
                  href={{
                    pathname: `/fashion/women`,
                    query: { category: WOMEN_CATEGORY[0].name },
                  }}
                  scroll={false}
                >
                  <a>
                    See All
                    // <RightOutlined />
                  </a>
                </Link> */}
              </div>
            </div>
            <div className="right_block">
              <div className="right_block_cover">
                <Slider2 colletionData={categoryData} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="mobile_view_section3">
        <div className="section_3_heading">
          <h4>Categories</h4>
          <Link
            href={{
              pathname: `/fashion/women/${categoryData && categoryData[0]?.slug}`,
              // query: { category: WOMEN_CATEGORY[0].name },
            }}
            scroll={false}
          >
            <div className="mobile_view_seeMore">
              <a>See More</a>
            </div>
          </Link>
        </div>
        <div className="mobile_view_section3_details_alignment">
          <div className="mobile_view_section3_details_bg">
            <Slider {...MobileshopByProduct}>
              {categoryData?.map((childSubCategory, index) => {
                return (
                  <React.Fragment key={index}>
                    <Link
                      href={{
                        pathname: `/fashion/women/${childSubCategory?.slug}`,
                        // query: { category: childSubCategory.name },
                      }}
                      scroll={false}
                    >
                      <div
                        className="mobile_view_gridItem"
                        onClick={() => {
                          dispatch(
                            fetchApplianceCategory({
                              modal: 'womenShopByCategory',
                              isOpen: true,
                              id: childSubCategory.name,
                              isMobile: false,
                            }),
                          )
                        }}
                      >
                        <div className="imgBox-alignment">
                          <img src={childSubCategory?.media} alt="Category_slider_cover_img" />
                        </div>
                        <div className="product_name-alignment">
                          <p>{childSubCategory?.name}</p>
                        </div>
                      </div>
                    </Link>
                  </React.Fragment>
                )
              })}
            </Slider>
          </div>
        </div>
      </section>
    </>
  )
}

const SampleNextArrow = (props) => {
  const { onClick } = props
  return (
    <div className="slick-arrow slick-next" onClick={onClick}>
      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 1L1 6L5 11" stroke="#1E2432" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}

const SamplePrevArrow = (props) => {
  const { onClick } = props
  return (
    <div className={'slick-arrow slick-prev'} onClick={onClick}>
      <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 1L1 6L5 11" stroke="#1E2432" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}

const Slider2 = ({ colletionData }) => {
  const dispatch = useAppDispatch()

  const settings_Slider2 = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 8,
    slidesToScroll: 8,
    autoplay: false,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 10,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 968,
        settings: {
          slidesToShow: 4.5,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
    ],
  }

  return (
    <>
      <div className="Category_slider">
        <Slider {...settings_Slider2}>
          {colletionData?.map((childSubCategory, index) => {
            return (
              <React.Fragment key={index}>
                <Link href={`/fashion/women/${childSubCategory?.slug}`} scroll={false}>
                  <div
                    className="Category_slider_cover"
                    onClick={() => {
                      dispatch(
                        fetchApplianceCategory({
                          modal: 'womenShopByCategory',
                          isOpen: true,
                          id: childSubCategory.name,
                          isMobile: false,
                        }),
                      )
                    }}
                  >
                    <div className="catagory_block">
                      <div className="box_cover">
                        <div className="box">
                          <div className="img_cover">
                            <img src={childSubCategory?.media} alt="Category_slider_cover_img" />
                          </div>
                        </div>
                      </div>
                      <p>{childSubCategory?.name}</p>
                    </div>
                  </div>
                </Link>
              </React.Fragment>
            )
          })}
        </Slider>
      </div>
    </>
  )
}
